// extracted by mini-css-extract-plugin
export default {"header":"index_header__MgLKl","avatarWrapper":"index_avatarWrapper__J6dKJ","sidebar":"index_sidebar__gLmDk","formWrapper":"index_formWrapper__trGcL"};